import { runFetch } from "../../index"

export const permissionsApi = (origin, token) => {
  return {
    get: async (applicationName) => {
      const resources = await runFetch(
        `/resources/${encodeURIComponent(applicationName)}`,
        token,
        origin
      )
      const lists = (resources?.resources || [])
        .filter((r) => r._links?.list?.href)
        .map((r) => ({
          name: r.resourceName,
          key: r._links.list.href,
          description: r.resourceDescription || ""
        }))

      return {
        resources,
        lists
      }
    },
    getListContent: async (href) => {
      const resources = await runFetch(href, token, origin)
      return resources
    }
  }
}
